module.exports = __webpack_public_path__ + "img/step3-order1.03c4b8b5.png";